<!-- Селект типа ЭДО-документа для фильтров и форм -->
<template>
  <base-select
    :model-value="modelValue"
    :options="options"
    :placeholder="placeholder"
    :clearable="clearable"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script>
export default {
  name: "EdoDocumentTypeSelect",

  props: {
    modelValue: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "Выберите тип документа",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["update:modelValue"],

  computed: {
    options() {
      return [
        {
          value: "TransportOrder",
          label: "Заказ-заявка на перевозку",
        },
        {
          value: "ConsignmentNote",
          label: "Транспортная накладная",
        },
        {
          value: "ForwarderOrder",
          label: "Поручение экспедитору",
        },
        {
          value: "ForwarderReceipt",
          label: "Экспедиторская расписка",
        },
      ];
    },
  },
};
</script>
